import { render, staticRenderFns } from "./Stack.vue?vue&type=template&id=53f277ce&"
import script from "./Stack.vue?vue&type=script&lang=ts&"
export * from "./Stack.vue?vue&type=script&lang=ts&"
import style0 from "./Stack.vue?vue&type=style&index=0&id=53f277ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports